module.exports = __webpack_public_path__ + "images/images/startLevel-067b1d7070320fa55a55bc2f2caa8c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/startLevel.png
// module id = 2534
// module chunks = 2